import type { Answer } from "./types";

// Answer types that should not be displayed to users
export const HIDDEN_ANSWER_TYPES: Answer["type"][] = [
  "Conditions",
  "Hidden Value",
  "Redirect",
  "Question Group",
] as const;

// The API records a Question Group's own response as a "description" answer holding this value; the
// group's answers follow it as separate sub-field responses, so the group row is only a heading.
export const QUESTION_GROUP_VALUE_PLACEHOLDER = "_question_group";
